import { render, staticRenderFns } from "./GetStartedState.vue?vue&type=template&id=59550b9c"
import script from "./GetStartedState.vue?vue&type=script&lang=js"
export * from "./GetStartedState.vue?vue&type=script&lang=js"
import style0 from "./GetStartedState.vue?vue&type=style&index=0&id=59550b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports